import Vue from 'vue'

const parse = require('url-parse')

const reload = (el) => {
  window.setTimeout(function () {
    const parsed = parse(el.src, true)
    parsed.set('query', {...parsed.query, rand: Math.random()})
    el.src = parsed.toString()
  }, 1000)
}

Vue.directive('reload', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {

    let errorTime = el.dataset.errorTime ? el.dataset.errorTime : 0

      // 图片载入错误时
    el.addEventListener('error', function (e) {

      errorTime++

      //console.log(errorTime)
      //console.log('error')

      if (errorTime <= 2) {
        el.dataset.errorTime = errorTime
        reload(el)
      }

    })
  }
})

Vue.directive('title', function (el, binding) {
  document.title = binding.value
})
